<template>
  <Suspend @close="close" ref="suspendRef"></Suspend>
</template>
<script>
import Suspend from "@/components/Suspend/index.vue";
import { transferRoleInfo, registReturnGameFunction, getKsTaskList, WebFragmentOnResume } from '@/bridge/AppJsBridge'
import { mapState } from 'vuex';
import { buryReportV2 } from "@/libs/business/account";

export default {
  data() {
    return {
    
    }
  },
  async mounted() {
    this.$store.dispatch('user/getCacheState');
    this.bridgeInit();
    setTimeout(() => {
      this.handleTab();
    }, 500)
  },
  computed: {
    ...mapState({
      userState: state => state.user
    })
  },
  components: {
    Suspend
  },
  methods: {
    bridgeInit() {
      transferRoleInfo(async (data, cb) => {
        data = JSON.parse(data);
        console.log('role info:', data);
        if (data.role_id && data.server_id && data.role_id != 0) {
          this.$store.commit('voucher/CHANGE_STATE', { showList: data });
          this.$store.commit('redEnvelope/CHANGE_STATE', {
            role: {
              ...data,
              server_num: data.server_id
            }
          })
          this.$store.commit('suspend/CHANGE_STATE', { role: data })
          this.$store.dispatch('activity/handleActivityShow', data);
          // 获取礼包数据
          this.$store.dispatch('suspend/getGiftData');
          // 判断福利红点用
          const appkey = this.$getStorage('appkey');
          const user_id = this.$getStorage('user_id');
          this.$store.dispatch('redEnvelope/getReceiveInfo', {
            params: {
              appkey,
              user_id,
              server_num: data.server_id,
              role_id: data.role_id,
            },
            fail: () => {},
          });
        }
      })

      /** $$ ks活动临时 */
      getKsTaskList((data) => {
        const _data = JSON.parse(data);
        console.log(44, _data);
        this.$store.commit('ks/CHANGE_STATE', { taskInitList: _data, taskInitState: true });
        this.$refs.suspendRef.getRealDay(_data);
      })
      /** -------- */
      WebFragmentOnResume(() => {
        this.$store.commit('suspend/CHANGE_STATE', { boxDownLoadShow: false })
      })
    },
    // 从 活动计划&闪页 跳转到活动悬浮球指定页面
    handleTab() {
      const { reRoute } = this.$route.query;
      if (reRoute) {
        const tabs = this.$store.state.suspend.tabs;
        const reRouteTab = tabs.find(item => item.type == reRoute);
        if (reRouteTab && reRouteTab.show == true) {
          this.$store.commit('suspend/CHANGE_STATE', { activeTab: reRouteTab });
          this.reRouteReport(reRouteTab.type)
        }
      }
    }, 
    reRouteReport(type) {
      const uploadCache = this.$getStorage('buryport') || {};
      if (type === 'welfare') {
        buryReportV2('SDK_MENU_PROFIT', { menu_name: "福利", ...uploadCache })
      }
    },
    close() {
      this.$refs.suspendRef.setSideBarState(false);
      setTimeout(() => {
        registReturnGameFunction(null);
      }, 800);
    }
  }
}
</script>